<script>
import { getHandoverString } from '@/utils/stringHandover'

export default {
  methods: {
    handleErrorType: function (errorType) {
      const params = getHandoverString('utm')
      if (errorType && params) {
        const query = JSON.parse(params)
        this.$router.push({ path: '/login', query: { e: errorType, ...query } }).catch(() => {})
      } else if (errorType) {
        this.$router.push({ path: '/login', query: { e: errorType } }).catch(() => {})
      } else if (params) {
        const query = JSON.parse(params)
        this.$router.push({ path: '/login', query }).catch(() => {})
      } else {
        this.$router.push({ path: '/login' }).catch(() => {})
      }
    },
  },
  created() {
    this.handleErrorType(this.$route.query.e)
  },
}
</script>

<style scoped></style>
